import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { logException } from '@ordersnproducts/modules/shared/utils/log-exception';
import { Observable } from 'rxjs';

export const NO_RETRY = 'NO_RETRY';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const useRetry = !req.headers.get(NO_RETRY);
    const pipeableFn = useRetry ? logException : () => (source: Observable<any>) => source;
    return next.handle(req).pipe(pipeableFn());
  }
}
